export default __webpack_public_path__ + "images/d21b31132ad725bf19b7a9e74aff45ed-1_mobile_659x494.jpg";